import { PreviousSectionNotCompleted } from "../_shared/Texts";

export default function IncompleteEnrollment() {
  return (
    <PreviousSectionNotCompleted>
      <p>Você precisa completar sua inscrição antes</p>
      <p>de prosseguir pra escolha de ingresso</p>
    </PreviousSectionNotCompleted>
  );
}
